export function getRandomUnity() {
  return Math.random() * (Math.random() > 0.5 ? -1 : 1);
}
